// extracted by mini-css-extract-plugin
module.exports = {"reports":"Reports_reports__ofml1"};